<template>
  <div class="addExperiment">
    <div class="addExperiment-title">
      <span>个人资料&nbsp;&nbsp; / &nbsp;&nbsp;</span>
      <i>编辑资料</i>
    </div>
    <div class="addExperiment-content">
      <div class="list">
        <div class="list-top"><span>头像</span></div>
        <div class="list-bottom">
          <upload-file
            :dir="`/avatar`"
            accept="image/gif, image/jpeg, image/jpg, image/png"
            @on-success="handleUploadSuccess"
          >
            <div class="avatar">
              <img
                src="https://img0.baidu.com/it/u=237841803,1211183193&fm=253&fmt=auto&app=138&f=JPG?w=500&h=500"
                style="width: 70px; height: 70px; border-radius: 50%"
                alt="avatar.png"
              />
              <div class="cover">
                <p>点击</p>
                <p>更换头像</p>
              </div>
            </div>
          </upload-file>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>用户名称</span></div>
        <div class="list-bottom">
          <el-input v-model="userName" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>大学名称</span></div>
        <div class="list-bottom">
          <el-input v-model="collegeName" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>性别</span></div>
        <div class="list-bottom">
          <el-radio-group v-model="sex">
            <el-radio :label="3">男</el-radio>
            <el-radio :label="6">女</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>电话</span></div>
        <div class="list-bottom">
          <el-input v-model="input" placeholder="请输入学时"></el-input>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>邮箱</span></div>
        <div class="list-bottom">
          <el-input v-model="input" placeholder="请输入学时"></el-input>
        </div>
      </div>
      <div class="list">
        <div class="list-top"><span>简介</span></div>
        <div class="list-bottom">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            v-model="textarea"
          >
          </el-input>
        </div>
      </div>
      <div class="list">
        <button class="btn" @click="goBack">取消</button>
        <button class="btn">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import uploadFile from "@/components/common/upload-file.vue";
export default {
  name: "VirtualimitationAddexperiment",
  components: { uploadFile },
  data() {
    return {
      active: 0,
      input: "",
      value: "",
      textarea: "",
      radio: 3,
    };
  },

  mounted() {},

  methods: {
    goBack() {
      history.go(-1);
    },
    /**
     * 处理上传成功
     */
    handleUploadSuccess(file) {
      this.$api.user
        .UpdatePortraitUrl({ portraitUrl: file.absolutePath })
        .then(() => {
          this.$Message.success("头像更换成功！");
            this.$store.commit("SET_USER", {
              ...this.user,
              portraitUrl: file.absolutePath,
            });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.addExperiment {
  width: 100%;
  .addExperiment-title {
    span,
    i {
      width: 147px;
      height: 20px;
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #424346;
      opacity: 1;
      font-style: normal;
    }
    span {
      color: #939393;
    }
  }
  .addExperiment-content {
    width: 100%;
    margin: 0 auto;
    padding-top: 31px;
    background: #fff;
    padding-bottom: 47px;
    .list {
      width: 824px;
      margin-bottom: 22px;
      margin: 0 auto 22px;
      .list-top {
        margin-bottom: 8px;
        display: flex;
        justify-content: start;
        .list-top-tabs {
          height: 25px;
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 500;
          line-height: 25px;
          color: #1880fa;
          cursor: pointer;
          &:nth-child(1) {
            margin-right: 37px;
          }
        }
        span {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #424346;
        }
        i {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #d51717;
          font-style: normal;
        }
        em {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: rgba(147, 147, 147, 0.55);
          opacity: 1;
          margin-left: 12px;
          font-style: normal;
        }
      }
      .list-bottom {
        display: flex;
        justify-content: start;
        align-items: center;
        .el-input,
        .el-select {
          width: 100%;
          height: 36px;
        }
        .download {
          margin-left: 35px;
          i {
            color: #1880fa;
          }
          strong {
            font-size: 14px;
            font-family: PingFang-SC;
            font-weight: 400;
            line-height: 20px;
            color: #1880fa;
            font-style: normal;
          }
        }
      }
    }
  }
  .addExperiment-title {
    margin-bottom: 16px;
    span,
    i {
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #424346;
      opacity: 1;
    }
    span {
      color: #939393;
      cursor: pointer;
    }
  }
  .btn {
    width: 84px;
    height: 36px;
    border: 1px solid #1880fa;
    border-radius: 4px;
    line-height: 36px;
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    color: #1880fa;
    background: #fff;
    cursor: pointer;
    &:nth-child(2) {
      background: #1880fa;
      color: #fff;
    }
  }
}
.addtabsActive {
  border-bottom: 2px solid #1880fa;
  span {
    color: #1880fa !important;
  }
}
.avatar {
  display: flex;
  justify-content: start;
  align-items: center;
  .cover {
    margin-left: 5px;
    p {
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #424346;
      opacity: 1;
    }
  }
}
</style>